var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgtext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 498,
    viewBox: "0 0 498 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2209_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4411 399.728L140.811 428.948L198.998 327.923",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3309 231.988C96.091 219.226 114.701 214.24 128.833 220.867L160.856 236.293C166.944 239.251 177.093 240.238 183.681 238.473L211.679 230.971C229.136 226.294 247.303 236.783 251.981 254.24L259.483 282.237C261.204 288.66 267.178 297.121 272.784 300.915L302.154 320.933C314.916 329.694 319.902 348.304 313.274 362.436L297.849 394.458C294.891 400.547 293.903 410.696 295.668 417.284L303.17 445.281C307.848 462.739 297.359 480.906 279.902 485.584L251.904 493.085C245.481 494.807 237.021 500.78 233.227 506.386L213.207 535.757C204.447 548.518 185.837 553.505 171.705 546.877L139.682 531.451C133.594 528.493 123.445 527.506 116.857 529.271L88.3656 536.906C70.9083 541.583 52.7409 531.094 48.0633 513.637L40.5172 485.475C38.7962 479.052 32.8664 470.756 27.4253 466.918L-1.82457 446.69C-14.4216 437.885 -19.364 419.44 -12.8568 405.517L2.36026 373.374C5.15368 367.33 6.14098 357.181 4.41995 350.758L-3.17023 322.431C-7.8479 304.974 2.64104 286.806 20.0983 282.129L48.59 274.494C55.0129 272.773 63.4737 266.799 67.267 261.194L87.3309 231.988Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2209_338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 498,
    height: 498,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgtext);
export default __webpack_public_path__ + "static/media/bgtext.a153b379a04cfd28acca7adb9f950968.svg";
export { ForwardRef as ReactComponent };